import React from "react";

import { AlignedRichTextBlock as Value } from "@reactivated";

import { injectComponents } from "../../utils/injection";
import { concatClassNames } from "../../utils/styles";
import { IntrinsicElementProps } from "../../utils/types";
import { AlignedRichTextSubBlock } from "../AlignedRichTextSubBlock";
import { ContainerSizeSubBlock } from "../ContainerSizeSubBlock";

import styles from "./index.module.scss";

type Props = React.PropsWithChildren<{
    /**
     * Streamfield Block value
     */
    value: Value;
    /**
     * Extra attributes to set on the top-level element.
     */
    attrs?: IntrinsicElementProps<HTMLDivElement>;
}>;

const dependencies = {
    ...AlignedRichTextSubBlock.dependencies,
    AlignedRichTextSubBlock,
    ContainerSizeSubBlock,
} as const;

export const AlignedRichTextBlock = injectComponents(dependencies)<Props>((
    props,
) => {
    const { AlignedRichTextSubBlock, ContainerSizeSubBlock } =
        props.dependencies;

    const attrs = props.attrs || {};
    attrs.className = concatClassNames([attrs.className, styles.container]);
    const content = props.value.content;
    if (!content) {
        return null;
    }
    return (
        <div {...attrs}>
            <ContainerSizeSubBlock value={props.value.container}>
                <AlignedRichTextSubBlock
                    dependencies={props.dependencies}
                    value={content}
                >
                    {props.children}
                </AlignedRichTextSubBlock>
            </ContainerSizeSubBlock>
        </div>
    );
});
